export const STATE_NAME_OPTIONS = [
    'Entry',
    'Pick up scan',
    'IN SCAN',
    'MANIFEST',
    'IN-COMING MANIFEST',
    'REMANIFEST',
    'DRS',
    'UNDELIVERED',
    'REDRS',
    'DELIVERED',
    'MISPLACED',
    'RTO',
    'CANCELLED',
    'INTRANSIT',
    'TRANSFER MANIFEST',
    'INCOMING TRANSFER MANIFEST',
    'UNDELIVERED/IN-TRANSIT RTO',
    'UNDELIVERED/RESCHEDULE',
    'RTO/TO SHIPPER',
    'DUTY EMAIL',
    'CUSTOMER INCOMING MANIFEST',
    'RTS',
    'DUTY EMAIL RESENT',
    'DUTY RECEIVED',
    'SHIPMENT READY FOR DISPATCH',
    'PARTIAL INSCAN',
    'PARTIAL MANIFESTED',
    'PARTIAL DELIVERED',
    'OFFLOADED',
    'SHIPMENT HOLD',
    'LOST',
    'DEPS',
    'ABANDONED',
    'CASE CLOSED',
    'ON-TRAIL',
    'HOLD',
    'SHIPMENT UNHOLD',
    'NOT PICKED',
    'BRANCH MANIFEST',
    'AWAITING CONNECTION',
    'RTO DELIVERED',
    'PARTIAL TRANSFER MANIFESTED',
    'PARTIAL DRS',
    'OPENED OR RETRIEVE',
    'LOCK MANIFESTED'
] as const;

export const EVENT_DATE_TIME_OPTIONS = [
    'Docket Booking date and time',
    'Actual event date and time',
    'Manifest created date and time',
    'Manifest date and time',
    'Incoming manifest actual arrival date',
    'DRS created date and time',
    'DRS date and time',
    'Mark Received date and time',
    'Manifest arrival date and time'
] as const;

export const EVENT_LOCATION_OPTIONS = [
    'Docket Origin',
    'Docket Destination',
    'Docket Shipper country',
    'Docket Consignee country',
    'Shipper City',
    'Consignee City',
    'Manifest Origin',
    'Manifest destination'
] as const;

export interface AwbState {
    _id: string;
    stateName: typeof STATE_NAME_OPTIONS[number];
    eventDateTime: typeof EVENT_DATE_TIME_OPTIONS[number];
    eventLocation: typeof EVENT_LOCATION_OPTIONS[number];
    eventDescription: string;
    status: 'Active' | 'Inactive';
    createdAt: string;
    updatedAt: string;
    createdBy?: string;
    updatedBy?: string;
}

export interface AwbStateFormData {
    stateName: string;
    eventDateTime: string;
    eventLocation: string;
    eventDescription: string;
    status: 'Active' | 'Inactive';
}

export interface AwbStateFilters {
    status?: string;
    stateName?: string;
    eventLocation?: string;
}

export interface AwbStateSearchParams {
    search?: string;
    filters?: AwbStateFilters;
    page?: number;
    limit?: number;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
}

export interface AwbStateApiResponse {
    success: boolean;
    data: AwbState[] | {
        data: AwbState[];
        total: number;
        page: number;
        limit: number;
        totalPages: number;
    };
    message?: string;
    timestamp?: string;
}

